import { useNavigate, useRouter } from '@tanstack/react-router';
import { Route as CatalogPropertiesRoute } from 'src/routes/catalog/properties.index';
import { Route as CatalogPropertiesPublicationsRoute } from 'src/routes/catalog/properties.publications';
import type { PropertiesSearch } from '../schemas/properties-search.schema';
import { toPropertyPublicationsSearch } from '../schemas/property-publications-search.schema';

/**
 * Returns to the preceding in-app entry without bypassing navigation blockers.
 * Direct-entry editors retain their catalog/publications fallback and filters.
 * @param backSearch - Validated catalog filters for direct-entry fallback.
 * @returns The editor's back action, shared by its header and error states.
 */
export const usePropertyEditorBack = (
  backSearch: PropertiesSearch
): (() => void) => {
  const { history } = useRouter();
  const navigate = useNavigate();

  return () => {
    if (history.canGoBack()) {
      history.back();
      return;
    }

    if (backSearch.returnTo === 'publications') {
      void navigate({
        to: CatalogPropertiesPublicationsRoute.to,
        search: toPropertyPublicationsSearch({
          ...backSearch,
          returnTo: undefined,
        }),
        replace: true,
      });
      return;
    }

    void navigate({
      to: CatalogPropertiesRoute.to,
      search: backSearch,
      replace: true,
    });
  };
};
